import * as q from '@/services/api/request/query';
import { encodePaginatableQuery, PaginatableQuery, Query } from '../../request';
import { encodeSortableQuery, SortableQuery } from '@/services/api/request/query';

export interface NotificationQuery extends PaginatableQuery, SortableQuery {
  search: string;
  from: Date | null;
  to: Date | null;
  status?: boolean;
}

export const encodeNotificationQuery = (query: NotificationQuery): Query => ({
  ...encodePaginatableQuery(query),
  ...encodeSortableQuery(query),
  search: q.string(query.search),
  from: q.nullableDate(query.from),
  to: q.nullableDate(query.to),
  status: query.status ? q.boolean(query.status) : '',
});
